"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.P2PWebRTCManager = void 0;
const new_peer_connection_1 = require("./new-peer-connection");
const logger_1 = require("../utils/logger");
class P2PWebRTCManager {
    constructor(senderFn, onNewRemoteTrack, onConnected, onDisconnected, trackFilterFn, sdpTransformFn) {
        this.receivedTracks = false;
        this.logger = new logger_1.Logger("P2PWebRTCManager", false);
        this.RTCTracks = [];
        this.pcs = {};
        this.connected = true;
        this.canCallPeers = false;
        this.sender = senderFn;
        this.onNewRemoteTrack = onNewRemoteTrack;
        this.onConnected = onConnected;
        this.onDisconnected = onDisconnected;
        this.trackFilterFn = trackFilterFn;
        this.sdpTransformFn = sdpTransformFn;
        this.MessageTypes = {
            'rtc--call-peer': (data) => {
                this.WaitUntilCanCallPeer().then(() => {
                    this.AddAndCallPeer(data.peer);
                });
                // Wait at least 6 seconds to actually get the list of peers before calling
                // this is because if we dont have the role of the user we actually get a list
                // of rtctracks that is empty as the filter function cant work
            },
            'rtc--answer': this.HandleRemoteSDP.bind(this),
            'rtc--offer': this.HandleRemoteSDP.bind(this),
            'rtc--candidate': this.HandleRemoteICECandidate.bind(this),
        };
    }
    async WaitUntilCanCallPeer() {
        return new Promise((resolve, reject) => {
            let interval = setInterval(() => {
                if (this.canCallPeers) {
                    clearInterval(interval);
                    // add artificial padding to ensure connection hopefully
                    // MAGIC: lets wait 1 second until we actually resolve the promise
                    // this is because sometimes the connection doesnt go through for some 
                    // weird reason.
                    window.setTimeout(() => {
                        resolve(true);
                    }, 1000);
                }
            }, 100);
        });
    }
    HandleRemoteICECandidate(data) {
        var _a;
        (_a = this.pcs[data.sender]) === null || _a === void 0 ? void 0 : _a.ProcessIceSignalIceCandidate(data);
    }
    async HandleRemoteSDP(data) {
        let pc = this.pcs[data.sender];
        let participantKey = data.sender;
        this.logger.log("Handle remote sdp", data);
        if (pc == null) {
            pc = new new_peer_connection_1.PeerConnection({
                recieveVideo: false
            }, (data) => {
                data.recipient = participantKey;
                this.sender(data);
            }, (track) => {
                this.logger.log("New track", data);
                // wrap handler to include sender info
                this.onNewRemoteTrack(track, data.sender);
            }, this.onDisconnected, this.sdpTransformFn);
            this.pcs[participantKey] = pc;
            this.WaitUntilCanCallPeer().then(() => {
                const filteredTracks = this.RTCTracks.filter((t) => this.trackFilterFn(t, participantKey));
                if (filteredTracks.length == 0) {
                    // something is totally wrong, what to do tho
                    alert("Error 1001: No audio set");
                }
                pc === null || pc === void 0 ? void 0 : pc.SetTracks(filteredTracks);
            });
            // window.setTimeout(() => {
            // }, 6000) // why 6 seconds? I think it is the same reason why we wait 2 seconds to call the peer
            // i think this number has to do with the list not being actually received
            // we have two choices wait til we actually receive the list, which would need some sort of event chaining
            // or have default list of tracks
            this.connected = true;
            this.onConnected(true); // connected handler
        }
        pc.HandleRemoteDescription(data);
    }
    SetBitrateForVideo(bitrate, ratio) {
        this.pcList().forEach((pc) => { pc.changeVideoBitrate(bitrate, ratio); });
    }
    SetBitrateForAudio(bitrate) {
        this.pcList().forEach((pc) => { pc.changeAudioBitrate(bitrate); });
    }
    SetRTCTracks(streams) {
        this.logger.log('setting tracks!', streams);
        if (streams.length == 0) {
            this.logger.error("Watchout, no streams are being set");
            return;
        }
        const mediaStreams = streams.filter((t) => typeof t !== 'undefined')
            .map((t) => ({
            label: t.label,
            stream: t.mediaStream,
        }));
        const tracks = mediaStreams.map((t) => {
            if (t.stream && t.stream.getTracks().length > 0) {
                return {
                    track: t.stream.getTracks()[0],
                    id: t.stream.id,
                    stream: t.stream,
                    label: t.label,
                };
            }
            return {
                track: null,
                id: "1",
                stream: t.stream,
                label: t.label,
            };
        });
        this.RTCTracks = tracks;
        this.logger.log('setting rtc tracks!', this.RTCTracks, this.pcs);
        Object.keys(this.pcs).map((key) => {
            const filteredTracks = this.RTCTracks.filter((t) => this.trackFilterFn(t, key));
            this.logger.log("Filtered tracks were", filteredTracks);
            this.pcs[key].SetTracks(filteredTracks);
        });
    }
    pcList() {
        return Object.keys(this.pcs).map((key) => this.pcs[key]);
    }
    getPC(participantKey) {
        return this.pcs[participantKey];
    }
    AddAndCallPeer(participantKey) {
        var _a;
        if (this.pcs[participantKey] != null) {
            (_a = this.pcs[participantKey]) === null || _a === void 0 ? void 0 : _a.Close();
            delete this.pcs[participantKey];
        }
        this.logger.log("ANYWHERE: Adding and calling peer: " + participantKey);
        window.setTimeout(() => {
            var _a;
            if (this.receivedTracks == false) {
                this.logger.error("ANYWHERE: We did not get tracks from the other peer");
                (_a = this.pcs[participantKey]) === null || _a === void 0 ? void 0 : _a.call();
            }
            else {
                this.logger.log("ANYWHERE: We did get tracks from the other peer, all good");
            }
        }, 5000);
        this.connected = true;
        this.onConnected(true); // connected handler
        this.logger.log('Call peer rtc tracks!', this.RTCTracks);
        this.pcs[participantKey] = new new_peer_connection_1.PeerConnection({
            recieveVideo: false,
        }, 
        // Sender FN
        (data) => {
            if (data.type == "rtc--no-audio") {
                this.AddAndCallPeer(participantKey);
                return;
            }
            data.recipient = participantKey;
            this.sender(data);
        }, (track) => {
            // wrap handler to include sender info
            this.logger.log("ANYWHERE: We did get a track from them");
            this.receivedTracks = true;
            this.onNewRemoteTrack(track, participantKey);
        }, this.onDisconnected, (sdp, type) => {
            return this.sdpTransformFn(sdp, type, participantKey);
        });
        const filteredTracks = this.RTCTracks.filter((t) => this.trackFilterFn(t, participantKey));
        this.logger.log("Filtered tracks were", filteredTracks, this.RTCTracks);
        this.pcs[participantKey].SetTracks(filteredTracks);
    }
    Close(participantKey) {
        var _a;
        (_a = this.pcs[participantKey]) === null || _a === void 0 ? void 0 : _a.Close();
        delete this.pcs[participantKey];
        this.logger.log("Deleting PC for the participant");
    }
}
exports.P2PWebRTCManager = P2PWebRTCManager;
